import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';
import { AppEpic } from '../../common/types/app-epic.type';
import { handleEpicError } from '../../common/utils/epics';
import {
  fetchPredictionModels,
  setPredictionModels,
} from '../actions/predictions.actions';
import { PredictionModelResource } from '../resources/prediction-model.resource';

export const fetchPredictionModelsEpic: AppEpic = (action$, state$) =>
  action$.pipe(
    filter(isActionOf(fetchPredictionModels)),
    switchMap(() => PredictionModelResource.getPredictionModels(state$.value)),
    map(models => setPredictionModels(models)),
    catchError(handleEpicError('Error retrieving available prediction models')),
  );
